import styles from './index.module.scss'
import { Switch, Popover, Slider, Button } from 'antd';
import { GenerateContext } from "../../../hooks/GenerateContext"
import { useContext, useState, useEffect} from "react"
import { QuestionCircleOutlined } from '@ant-design/icons';
import { RELIGHT_MODE, IMAGE_TYPE } from "@utils/CONST"

const BASE_URL = 'https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/batchProduceImages/'

const Relight = (props) => {
    const { imageType } = props
    const {
        relight, setRelight,
        relightMode, setRelightMode
    } = useContext(GenerateContext)
    const [checkedVal, setCheckedVal] = useState(false)

    useEffect(() => {
        setCheckedVal(relight > 0)
    }, [relight])

    const items = [{
        text: '标准',
        value: RELIGHT_MODE.SKIN,
    }, {
        text: '人像',
        value: RELIGHT_MODE.PORTRAIT,
    }, {
        text: '反光板模式',
        value: RELIGHT_MODE.REFLECTOR,
    }].filter(item => {
        if (imageType === IMAGE_TYPE.BACKGROUND && item.value === RELIGHT_MODE.PORTRAIT) return false
        return true
    })

    const contentList = [{
        url: '1.png',
        title: '标准模式',
        smallTitle: '使人物与环境的光影和谐一致',
    }, {
        url: '2.png',
        title: '人像模式',
        smallTitle: '使人脸与身体的光影和谐一致',
    }, {
        url: '3.png',
        title: '反光板模式',
        smallTitle: '使人脸光影更柔和，降低对比度',
    }].filter(item => {
        if (imageType === IMAGE_TYPE.BACKGROUND && item.url === '2.png') return false
        return true
    })

    const ContentBox = (
        <div className={styles.ContentBox}>
            {
                contentList.map((item) => (
                    <div key={item.value} className={styles.ContentItem}>
                        <img src={BASE_URL + item.url} alt={item.title} />
                        <div className={styles.title}>{item.title}</div>
                        <div className={styles.smallTitle}>{item.smallTitle}</div>
                    </div>
                ))
            }
        </div>
    )

    return (
        <div className={styles.RelightWrap}>
            <div className={styles.Relight}>
                <div className={styles.title}>光影增强
                    <Popover content={ContentBox} placement="right">
                        <QuestionCircleOutlined style={{ marginLeft: 8, cursor: 'pointer' }} />
                    </Popover>
                </div>
                <div className={styles.switch}><Switch style={{ marginRight: 8 }}
                    checked={checkedVal}
                    onChange={(v) => {
                        setCheckedVal(v)
                        setRelight(v ? 1.0 : 0.0)
                    }} />{checkedVal ? '开启' : '关闭'}</div>
            </div>
            {
                relight > 0.0 && <div className={styles.PickerContent}>
                    {
                        items.map((item) => (
                            <Button
                                key={item.value}
                                className={`${styles.PickerItem} ${relightMode == item.value && styles.actived}`}
                                onClick={() => setRelightMode(item.value)}
                            >
                                {item.text}
                            </Button>
                        ))
                    }
                </div>
            }

            {
                relight > 0.0 && <div className={styles.SliderWrap}>
                    <span>更像原图</span>
                    <Slider className={styles.Slider} max={1.4} min={0.8} value={relight} step={0.1} onChange={value => setRelight(value)} />
                    <span>更加自然</span>
                </div>
            }
        </div>
    )
}


export default Relight